import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleKiloleteMaster } from "../../../Api/api";





export const addKiloleterMasterAsync=createAsyncThunk(
   "kiloleterMaster/add",
   async ({ data, done, err }) => {
         try {
            const response = await handleKiloleteMaster(data);
            done && done();
            return response.data;
         } catch (error) {
            // You can customize the error handling here
            
            err && err();
            throw error.response.data;
         }
      }
);




